import React from 'react';
import { Link } from 'react-router-dom'; // For navigation, using react-router

const Footer = () => {
    return (
        <footer className="bg-gray-800 text-white  w-full py-2 ">
            <div className="max-w-6xl mx-auto px-4 text-center">
                <p className="text-sm mb-2">© 2025 Wait, When's Your Birthday. All rights reserved.</p>
                <div className="flex justify-center space-x-4">
                    <Link to="/terms" className="text-blue-400 hover:underline text-sm">
                        Terms of Service
                    </Link>
                    <span>|</span>
                    <Link to="/privacy" className="text-blue-400 hover:underline text-sm">
                        Privacy Policy
                    </Link>
                </div>
            </div>
        </footer>
    );
}

export default Footer;
